<organization-top-navbar></organization-top-navbar>

<!-- Hero Section -->
<section class="hero-section">
    <div class="hero-bg-overlay"></div>
    <div class="container hero-grid">
        <div class="hero-text-content">
            <h1 class="hero-title">{{'LOGIN.WELCOME' | transloco}}</h1>
            <div class="hero-tagline">{{ 'CUSTOMER_PAGE.PARK_SMARTER' | transloco }} {{ 'CUSTOMER_PAGE.TRAVEL_EASIER' |
                transloco }}</div>
            <p class="hero-subtitle">
                {{ 'CUSTOMER_PAGE.BOOK_PARKING_DESCRIPTION' | transloco }}
            </p>

            <!-- In-Page Actions: Login & Manage Booking -->
            <div class="hero-page-actions">
                @if (!authService.loggedIn()) {
                <button type="button" class="page-action-btn primary-action" (click)="login()">
                    <div class="action-btn-icon">
                        <mat-icon>login</mat-icon>
                    </div>
                    <div class="action-btn-text">
                        <span class="action-btn-title">{{ 'FORM.LOGIN' | transloco }}</span>
                        <span class="action-btn-sub">{{'CUSTOMER_PAGE.ACCESS_ORDERS' | transloco}}</span>
                    </div>
                </button>
                } @else {
                <button type="button" class="page-action-btn primary-action" (click)="goToOrders()">
                    <div class="action-btn-icon">
                        <mat-icon>account_circle</mat-icon>
                    </div>
                    <div class="action-btn-text">
                        <span class="action-btn-title">{{'CUSTOMER_PAGE.MY_ACCOUNT' | transloco}}</span>
                        <span class="action-btn-sub">{{'CUSTOMER_PAGE.VIEW_ORDERS' | transloco}}</span>
                    </div>
                </button>
                }

                <button type="button" class="page-action-btn secondary-action" (click)="goToHandleBooking()">
                    <div class="action-btn-icon">
                        <mat-icon>edit_calendar</mat-icon>
                    </div>
                    <div class="action-btn-text">
                        <span class="action-btn-title">{{ 'PARKIFLY.HOME.MANAGE_BOOKING' | transloco }}</span>
                        <span class="action-btn-sub">{{'CUSTOMER_PAGE.FIND_OR_CHANGE_BOOKING' | transloco}}</span>
                    </div>
                </button>
            </div>

            <div class="hero-badges">
                <div class="hero-badge-item">
                    <div class="hero-badge-icon">
                        <mat-icon class="badge-mat-icon">shield</mat-icon>
                    </div>
                    {{ 'CUSTOMER_PAGE.SECURE_PARKING' | transloco }}
                </div>
                <div class="hero-badge-item">
                    <div class="hero-badge-icon">
                        <mat-icon class="badge-mat-icon">flight_takeoff</mat-icon>
                    </div>
                    {{ 'CUSTOMER_PAGE.CLOSE_TO_AIRPORT' | transloco }}
                </div>
            </div>
        </div>

        <!-- Booking Card Widget -->
        <div class="booking-card">
            <!-- Step 1 -->
            <div class="step-block">
                <div class="step-header">
                    <span class="step-number">1</span> {{ 'CUSTOMER_PAGE.SELECT_AIRPORT' | transloco }}
                </div>
                <div class="airport-options">
                    <div class="airport-radio-card" [class.selected]="selectedAirport === 'arlanda'"
                        (click)="selectAirport('arlanda')">
                        <div class="custom-radio"></div>
                        <div>
                            <div class="airport-info-title">
                                <mat-icon class="airport-title-icon">flight_takeoff</mat-icon>
                                Arlanda
                            </div>
                            <div class="airport-info-sub">{{ 'CUSTOMER_PAGE.CHOOSE_PARKING_PARTNER' | transloco }}</div>
                        </div>
                    </div>

                    <div class="airport-radio-card" [class.selected]="selectedAirport === 'skavsta'"
                        (click)="selectAirport('skavsta')">
                        <div class="custom-radio"></div>
                        <div>
                            <div class="airport-info-title">
                                <mat-icon class="airport-title-icon">airport_shuttle</mat-icon>
                                Skavsta
                            </div>
                            <div class="airport-info-sub">{{ 'CUSTOMER_PAGE.DIRECT_PARKING' | transloco }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="step-block">
                <div class="step-header">
                    <span class="step-number">2</span> Select your dates
                </div>
                <div class="dates-picker-grid">
                    <div class="date-box" (click)="openFromDatePicker()" class="cursor-pointer">
                        <span class="date-label">Parking from</span>
                        <span class="date-val">
                            <mat-icon class="val-icon">calendar_today</mat-icon>
                            <ng-container *ngIf="fromDate; else noFromDate">
                                {{ fromDate | date:'yyyy/MM/dd' }} {{ 'PARKIFLY.CLOCK_SHORT' | transloco }} {{ fromDate
                                | date:'HH:mm' }}
                            </ng-container>
                            <ng-template #noFromDate>
                                {{ 'PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_DEPARTURE_DATE_PLACEHOLDER' |
                                transloco }}
                            </ng-template>
                        </span>
                    </div>
                    <mat-icon class="date-arrow-icon">east</mat-icon>
                    <div class="date-box" (click)="openToDatePicker()" class="cursor-pointer">
                        <span class="date-label">Parking to</span>
                        <span class="date-val">
                            <mat-icon class="val-icon">calendar_today</mat-icon>
                            <ng-container *ngIf="toDate; else noToDate">
                                {{ toDate | date:'yyyy/MM/dd' }} {{ 'PARKIFLY.CLOCK_SHORT' | transloco }} {{ toDate |
                                date:'HH:mm' }}
                            </ng-container>
                            <ng-template #noToDate>
                                {{ 'PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_ARRIVAL_DATE_PLACEHOLDER' | transloco
                                }}
                            </ng-template>
                        </span>
                    </div>
                </div>
            </div>

            <button class="btn-booking-submit" [disabled]="!fromDate || !toDate" (click)="onContinueSearch()">
                {{ 'CUSTOMER_PAGE.CONTINUE_TO_SEARCH' | transloco }}
            </button>
        </div>
    </div>
</section>

<!-- TUI Discount Banner -->
<!-- <section class="tui-banner-section container">
    <div class="tui-card">
        <div class="tui-content">
            <div class="tui-logo">TUI</div>
            <h2 class="tui-title">{{ 'CUSTOMER_PAGE.TUI_DISCOUNT' | transloco }}</h2>
            <p class="tui-desc">{{ 'CUSTOMER_PAGE.TUI_DISCOUNT_DESCRIPTION' | transloco }}</p>
            <a href="#" class="tui-btn" [routerLink]="['/parkifly/tui']">{{ 'CUSTOMER_PAGE.VIEW_OFFER' | transloco }}
                <mat-icon class="inline-btn-icon">east</mat-icon></a>
        </div>

        <img src="assets/img/tui-offer-beach.jpg" alt="Tropical Beach TUI Offer" class="tui-image" />
    </div>
</section> -->

<!-- Our Airports -->
<section class="airports-grid-section container">
    <div class="section-title-row">
        <h2 class="section-title">{{ 'CUSTOMER_PAGE.OUR_AIRPORTS' | transloco }}</h2>
    </div>

    <div class="airports-grid">
        <!-- Arlanda Card -->
        <div class="airport-card">
            <img src="assets/img/arlanda-airport.jpg" class="airport-card-img" alt="Arlanda Airport" />
            <div class="airport-card-body">
                <h3 class="airport-card-title">Arlanda Airport</h3>
                <p class="airport-card-desc">{{ 'CUSTOMER_PAGE.CHOOSE_DATES_DESCRIPTION' | transloco }}</p>

                <div class="partners-row">
                    <span class="partner-pill" [routerLink]="['/parkifly/flygets']">Flygets Parking</span>
                    <!-- <span class="partner-pill" [routerLink]="['/parkifly/quality-landing-page']"
                        [queryParams]="{ public: true }">Quality
                        XPO</span>
                    <span class="partner-pill" [routerLink]="['/parkifly/aiden-landing-page']"
                        [queryParams]="{ public: true }">Aiden
                        Hotel</span>
                    <span class="partner-pill" [routerLink]="['/parkifly/tui']">TUI Parking</span>
                    <span class="partner-pill" [routerLink]="['/parkifly/nazar']">Nazar Parking</span> -->
                </div>

            </div>
        </div>

        <!-- Skavsta Card -->
        <div class="airport-card">
            <img src="assets/img/skavsta-airport.jpg" class="airport-card-img" alt="Skavsta Airport" />
            <div class="airport-card-body">
                <h3 class="airport-card-title">Skavsta Airport</h3>
                <p class="airport-card-desc">{{ 'CUSTOMER_PAGE.LONG_TERM_PARKING_DESCRIPTION' | transloco }}</p>

                <div class="partners-row">
                    <span class="partner-pill" [routerLink]="['/parkifly/skavsta']">Skavsta Parking</span>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- More than just parking -->
<!-- <section class="services-section container">
    <div class="section-title-row">
        <div>
            <h2 class="section-title">{{ 'CUSTOMER_PAGE.HOTEL_AND_TRANSFER' | transloco }}</h2>
            <p class="section-subtitle">{{ 'CUSTOMER_PAGE.HOTEL_AND_TRANSFER_DESCRIPTION' | transloco }}</p>
        </div>
    </div>

    <div class="services-grid">
        <div class="service-card hotel-transfer-card"
            [routerLink]="['/booking-service/417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1']">
            <div class="hotel-logo-box">
                <img src="assets/img/Scandic_logo.svg" alt="Scandic Hotel" class="hotel-card-logo" />
            </div>
            <h3 class="service-title">Scandic Hotel</h3>
            <span class="service-link">Book Hotel & Transfer <mat-icon class="inline-link-icon">east</mat-icon></span>
        </div>

        <div class="service-card hotel-transfer-card"
            [routerLink]="['/booking-service/5BF79F25-27BF-4B5B-AF83-B4A0233DAB70']">
            <div class="hotel-logo-box">
                <img src="assets/img/apartdirect.jpg" alt="ApartDirect" class="hotel-card-logo" />
            </div>
            <h3 class="service-title">ApartDirect</h3>
            <span class="service-link">Book Hotel & Transfer <mat-icon class="inline-link-icon">east</mat-icon></span>
        </div>

        <div class="service-card hotel-transfer-card"
            [routerLink]="['/booking-service/39218780-069A-4C6B-9925-22365A075C15']">
            <div class="hotel-logo-box">
                <img src="assets/img/quality-hotel-airport-arlanda.svg" alt="Quality XPO" class="hotel-card-logo" />
            </div>
            <h3 class="service-title">Quality Hotel Arlanda XPO</h3>
            <span class="service-link">Book Hotel & Transfer <mat-icon class="inline-link-icon">east</mat-icon></span>
        </div>

        <div class="service-card hotel-transfer-card"
            [routerLink]="['/booking-service/D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251']">
            <div class="hotel-logo-box">
                <img src="assets/img/Aiden-hotel-logo.svg" alt="Aiden Hotel" class="hotel-card-logo"
                    class="max-height-75" />
            </div>
            <h3 class="service-title">Aiden Hotel</h3>
            <span class="service-link">Book Hotel & Transfer <mat-icon class="inline-link-icon">east</mat-icon></span>
        </div>
    </div>
</section> -->

<!-- Drive-Up Booking Bar -->
<section class="driveup-section container">
    <div class="driveup-bar">
        <div class="driveup-left">
            <div class="driveup-icon-box"><mat-icon class="driveup-mat-icon">directions_car</mat-icon></div>
            <div>
                <h3 class="driveup-title">{{ 'CUSTOMER_PAGE.DRIVE_UP_BOOKING' | transloco }}</h3>
                <p class="driveup-desc">{{ 'CUSTOMER_PAGE.SEARCH_BOOKING_BY_REGISTRATION' | transloco }}</p>
            </div>
        </div>

        <div class="driveup-right">
            <div class="license-plate-box">
                <div class="eu-flag-strip">
                    <span>★</span>
                    <span>S</span>
                </div>
                <input type="text" class="license-input" placeholder="XXX 111"
                    [formControl]="driveInBookingForm.controls.registrationNumber" (keyup)="regToUpper()" />
            </div>
            <button class="btn-search-plate" (click)="submitForm()" [disabled]="isLoading">
                <ng-container *ngIf="!isLoading">Search</ng-container>
                <mat-progress-spinner *ngIf="isLoading" diameter="20" mode="indeterminate"
                    class="display-inline-block-center"></mat-progress-spinner>
            </button>
        </div>
    </div>
</section>

<!-- Yellow Partners & Extra Services Banner -->
<section class="yellow-partners-section container">
    <div class="yellow-banner-card">
        <div>
            <h3 class="yellow-left-title">{{ 'CUSTOMER_PAGE.PARTNERS_AND_EXTRA_SERVICES' | transloco }}</h3>
            <p class="yellow-left-sub">{{ 'CUSTOMER_PAGE.PARTNER_CAR_CARE_DESCRIPTION' | transloco }}</p>

            <div class="partner-icons-row">
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">handyman</mat-icon>
                    <span>Window repair</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">battery_charging_full</mat-icon>
                    <span>Battery charge</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">airport_shuttle</mat-icon>
                    <span>Big car parking</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">local_car_wash</mat-icon>
                    <span>Car wash</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">garage</mat-icon>
                    <span>Indoor parking</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">home_repair_service</mat-icon>
                    <span>Car service</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">published_with_changes</mat-icon>
                    <span>Change parking</span>
                </div>
                <div class="partner-icon-tile" [routerLink]="['/parkifly/flygets']">
                    <mat-icon class="tile-mat-icon">build</mat-icon>
                    <span>Stone chip repair</span>
                </div>
            </div>
        </div>

        <!-- Carglass Box -->
        <div class="carglass-card" [routerLink]="['/parkifly/flygets']" class="cursor-pointer">
            <div class="discount-badge-star">25%</div>
            <h4 class="carglass-title">{{ 'CUSTOMER_PAGE.CARGLASS_OFFER' | transloco }}</h4>
            <a [routerLink]="['/parkifly/flygets']" class="carglass-btn">{{ 'CUSTOMER_PAGE.VIEW_OFFER' | transloco }}
                <mat-icon class="inline-btn-icon">east</mat-icon></a>
            <div class="text-bold-red-16">CARGLASS</div>
        </div>
    </div>
</section>

<!-- Bottom Promos -->
<section class="bottom-promos-section container">
    <div class="promos-grid">
        <!-- App Download Card -->
        <div class="promo-card app-promo-card">
            <!-- Left Info Block -->
            <div class="promo-left-block">
                <h3 class="promo-card-title">{{ 'CUSTOMER_PAGE.DOWNLOAD_PARKIFLY_APP' | transloco }}</h3>
                <p class="promo-card-sub">{{ 'CUSTOMER_PAGE.APP_DESCRIPTION' | transloco }}</p>

                <ul class="checklist">
                    <li>{{ 'CUSTOMER_PAGE.VIEW_MODIFY_OR_CANCEL_BOOKING' | transloco }}</li>
                    <li>{{ 'CUSTOMER_PAGE.GET_FLIGHT_UPDATES' | transloco }}</li>
                    <li>{{ 'CUSTOMER_PAGE.RECEIVE_IMPORTANT_INFORMATION' | transloco }}</li>
                    <li>{{ 'CUSTOMER_PAGE.SMOOTHER_TRAVEL_EXPERIENCE' | transloco }}</li>
                </ul>

                <div class="app-badges">
                    <div class="app-badge-btn">
                        <mat-icon class="app-mat-icon">phone_iphone</mat-icon>
                        <div>{{ 'CUSTOMER_PAGE.DOWNLOAD_ON_APP_STORE' | transloco }}<br><strong>App Store</strong></div>
                    </div>
                    <div class="app-badge-btn">
                        <mat-icon class="app-mat-icon">play_arrow</mat-icon>
                        <div>GET IT ON<br><strong>Google Play</strong></div>
                    </div>
                </div>
            </div>

            <!-- Middle "Coming Soon" Feature Box -->
            <div class="promo-middle-block">
                <div class="coming-soon-card">
                    <div class="coming-soon-badge">
                        <span class="badge-pulse-dot"></span>
                        <mat-icon class="badge-icon">rocket_launch</mat-icon>
                        <span>{{ 'CUSTOMER_PAGE.COMING_SOON' | transloco }}</span>
                    </div>

                    <h4 class="coming-soon-heading">{{ 'CUSTOMER_PAGE.MOBILE_EXPERIENCE_TITLE' | transloco }}</h4>
                    <p class="coming-soon-text">
                        {{ 'CUSTOMER_PAGE.MOBILE_EXPERIENCE_DESCRIPTION' | transloco }}
                    </p>

                    <div class="feature-teasers">
                        <div class="feature-teaser-item">
                            <mat-icon class="teaser-icon">qr_code_2</mat-icon>
                            <span>{{ 'CUSTOMER_PAGE.FEATURE_QR_CHECKIN' | transloco }}</span>
                        </div>
                        <div class="feature-teaser-item">
                            <mat-icon class="teaser-icon">notifications_active</mat-icon>
                            <span>{{ 'CUSTOMER_PAGE.FEATURE_FLIGHT_ALERTS' | transloco }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Image Block -->
            <div class="promo-right-block">
                <div class="img-wrapper phone-mockup">
                    <img src="assets/img/app_ss.png" class="promo-img-box app-ss-img" alt="Parkifly App Screenshot" />
                </div>
            </div>
        </div>

        <!-- Inspiration Card -->
        <!-- <div class="promo-card">
            <div>
                <h3 class="promo-card-title">Travel inspiration and offers</h3>
                <p class="promo-card-sub">Get tips for your next trip and exclusive offers.</p>

                <a href="#" class="tui-btn margin-top-20">See all offers <mat-icon
                        class="inline-btn-icon">east</mat-icon></a>

                <div
                    class="flex-gap-12-mt-24">
                    <span>VING</span>
                    <span>TUI</span>
                </div>
            </div>

            <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=400&q=80"
                class="promo-img-box" alt="Travel Offers" />
        </div> -->
    </div>
</section>

<!-- Footer -->
<footer class="site-footer">
    <div class="container footer-inner">
        <div class="footer-logo-wrapper">
            <img src="assets/img/ParkiFly-logo.svg" alt="ParkiFly Logo" class="footer-parkifly-logo" />
        </div>

        <div class="footer-copyright">
            &copy; {{ currentYear }} Powered by <a target="_blank">Parkifly AB, Org.nr: 559454-6698, Wallingatan 42,
                111 24 Stockholm, Sweden</a>
            &middot; <a [routerLink]="['/terms-and-conditions']">Terms</a>
        </div>
    </div>
</footer>